import { getCookieValue, setRawCookie } from 'Utilities';

import {
  CONSENT_COOKIE_EXPIRY_DAYS,
  CONSENT_COOKIE_NAME,
} from './cookieConsent.constants';
import type { ConsentObject } from './cookieConsent.types';

export const hasStoredConsent = (): boolean => Boolean(getCookieValue(CONSENT_COOKIE_NAME));

export const storeConsent = (consent: ConsentObject): void => {
  setRawCookie(CONSENT_COOKIE_NAME, JSON.stringify(consent), CONSENT_COOKIE_EXPIRY_DAYS);
};

export const pushConsentToGTM = (consent: ConsentObject): void => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dataLayer = window.dataLayer || [];

  // Google Consent Mode only recognises consent commands issued through the
  // gtag() pattern, which pushes the native `arguments` object onto the
  // dataLayer. Pushing a plain array (`['consent', 'update', {...}]`) is NOT
  // interpreted by GTM as a consent command, so the consent state never
  // updates and tags keep firing regardless of the chosen preferences.
  // gtag relies on pushing the native `arguments` object (not a plain array),
  // which is how GTM detects and processes Consent Mode commands. The typed
  // params only exist to constrain the call; the values are forwarded via
  // `arguments`.
  // eslint-disable-next-line func-names, @typescript-eslint/no-unused-vars
  function gtag(_command: 'consent', _action: 'update', _consent: ConsentObject) {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments as unknown as Record<string, unknown>);
  }

  gtag('consent', 'update', consent);
};

export const applyConsent = (consent: ConsentObject): void => {
  storeConsent(consent);
  pushConsentToGTM(consent);
};
